import { Row } from 'antd';
import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 24px;
  padding: 24px;
  background-color: ${(props) => props.theme.colors.primary};

  /* .depositante:not(td) {
       // background-color: #D6E4FF !important;
    }

    .fornecedor:not(td) {
       // background-color: #F4FFB8 !important;
    } */

  @media (max-width: 991.98px) {
    .ant-btn > span + span {
      display: none;
    }
  }
`;

export const TitleContainer = styled(Row)`
  justify-content: space-between;
  @media (max-width: 450px) {
    flex-direction: column;
    margin-bottom: 16px;
  }
`;

export const SubTotal = styled.div`
  .subtotal {
  }
`;

export const IconTable = styled.div`
  text-align: center;
`;

export const TableStyle = styled.div`
  .ant-table-thead > tr > th {
    background: #f0f0f0;
  }
  .ant-table {
    background: #f8f8f8;
  }
`;
